import LatestJobs from './LatestJobs.vue';

export default {
    LatestJobs
}